module.exports = __webpack_public_path__ + "img/symbol_12.40ee7fe0.png";